import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, timeout: 120000 });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("beacon_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// ---- step-up re-auth: the server gates sensitive actions, we prompt and retry ----
let stepUpHandler = null;

export function onStepUpRequired(handler) {
  stepUpHandler = handler;
  return () => { stepUpHandler = null; };
}

function isStepUp(err) {
  const d = err.response?.data?.detail;
  return err.response?.status === 403 && d && typeof d === "object" && d.code === "step_up_required";
}

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const url = err.config?.url || "";
    const isAuthCall = /\/auth\/(login|invite|2fa|step-up|password)/.test(url);
    if (err.response?.status === 401 && !isAuthCall && localStorage.getItem("beacon_token")) {
      // the session was ended elsewhere (password change, 2FA reset, log out everywhere)
      localStorage.removeItem("beacon_token");
      if (window.location.pathname !== "/login") window.location.replace("/login?ended=1");
      return Promise.reject(err);
    }
    if (!isStepUp(err) || err.config?._retriedAfterStepUp || !stepUpHandler) return Promise.reject(err);
    const detail = err.response.data.detail;
    const confirmed = await new Promise((resolve) => stepUpHandler({ ...detail, resolve }));
    if (!confirmed) return Promise.reject(err);
    return api({ ...err.config, _retriedAfterStepUp: true });
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
